import en from './en.json';
import fr from './fr.json';

export const financialStatementsI18n = {
  fr,
  en,
};
